module.exports = __webpack_public_path__ + "img/PRCA1_Plasma.0e031120.png";